import React from 'react'
import {CFComponentProps} from 'module/CustomField/type/CFComponentType'
import {CFMember, CFValue} from 'module/CustomField/type/CFType'
import {useDqSearchRx} from 'module/Slct/impl/hook/useDqSearchRx'
import {css} from '@emotion/react'
import {getOptionLabel} from 'module/Slct/util/getOptionLabel'
import {SlctFormat} from 'module/Slct/type/SlctType'
import {CircularProgress} from '@mui/material'
import {cssSlctEllipsis, cssSlctPlaceholderText} from 'module/Slct/style/SlctStyle'

export const CustomFieldLabelComponent = React.memo(function CustomFieldLabelComponent(props: CFComponentProps<CFValue | CFMember>) {
	const {
		modelValue,
		placeholderHTML,
	} = props

	const {
		suggestions,
		loading,
	} = useDqSearchRx(props)


	return (
		<div className={'CustomFieldLabelComponent'}>
			{modelValue && <div dangerouslySetInnerHTML={{__html: modelValue}}/>}
			{loading && <CircularProgress size={'inherit'}/>}
			{!suggestions.length && placeholderHTML &&
				<div
					css={[cssSlctPlaceholderText, cssSlctEllipsis]}
					dangerouslySetInnerHTML={{__html: placeholderHTML || ''}}
				/>
			}
			{suggestions.map(o => {
				if (!o) return null;
				let style = '';
				if (o?.valuebackground || o?.background) {
					style += `background: ${o?.valuebackground || o?.background || '#ffffff'};`
				}
				if (o?.valuecolor || o?.color) {
					style += `color: ${o?.valuecolor || o?.color || '#000000'};`
				}
				return <div css={style ? css(style) : undefined}>
					{getOptionLabel(SlctFormat.Label, o)}
				</div>
			})}
		</div>
	)
})